import TeamsBaseComponent, {ITeamsBaseComponentState} from "msteams-react-base-component";
import {MessageBar, MessageBarType} from "office-ui-fabric-react";
import React = require("react");

export interface TeamsDocumentStatusTabBannerState extends ITeamsBaseComponentState {}

export interface TeamsDocumentStatusTabBannerProps {
    isSuccess: boolean;
    isError: boolean;
    bannerMessage: string;
    onDismiss: () => void;
}

export class TeamsDocumentStatusTabBanner extends TeamsBaseComponent<
    TeamsDocumentStatusTabBannerProps,
    TeamsDocumentStatusTabBannerState
> {
    constructor(props: TeamsDocumentStatusTabBannerProps) {
        super(props);
    }

    public render() {
        return (
            <MessageBar
                messageBarType={
                    this.props.isSuccess
                        ? MessageBarType.success
                        : this.props.isError
                        ? MessageBarType.error
                        : MessageBarType.warning
                }
                isMultiline={true}
                onDismiss={this.props.onDismiss}
            >
                <div style={{fontSize: "14px"}}>{this.props.bannerMessage}</div>
            </MessageBar>
        );
    }
}
